import { createContext, useContext, useState } from 'react';
import { EnglishData } from '../Data/English';
import { GermanData } from '../Data/German';
// import { ChineseData } from '../Data/Chinese';
import { FrenchData } from '../Data/French';
import { SpanishData } from '../Data/Spanish';
import { DutchData } from '../Data/Dutch';
const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('LangEnglish');

  const languageConfig = {
    LangEnglish: EnglishData,
    LangGerman: GermanData,
    LangDutch: DutchData,
    LangFrench: FrenchData,
    LangSpanish: SpanishData,
  };

  const changeLanguage = (newLanguage) => {
    setLanguage(newLanguage);
  };

  const getLanguageData = () => {    
    const data = languageConfig[language] ? languageConfig[language][0] : EnglishData[0];
    // console.log("Language Data:", data);
    return data;
  };

  const languagesList = [
    {
      id: 'LangDutch',
      name: 'Dutch',
      flag: '/Assets/images/globe.svg',
    },
    {
      id: 'LangEnglish',
      name: 'English',
      flag: '/Assets/images/globe.svg',
    },
    {
      id: 'LangFrench',
      name: 'French',
      flag: '/Assets/images/globe.svg',
    },
    {
      id: 'LangGerman',
      name: 'German',
      flag: '/Assets/images/globe.svg',
    },
    {
      id: 'LangSpanish',
      name: 'Spanish',
      flag: '/Assets/images/globe.svg',
    }
  ];


  return (
    <LanguageContext.Provider value={{ language, changeLanguage, languagesList, languageConfig, getLanguageData    }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  return useContext(LanguageContext);
};
